import { useQuery } from '@tanstack/react-query';
import type { SynchronousQueryConfig } from 'lib/react-query';
import queryString from 'query-string';
import { apiClient } from 'lib/api';
import queryKeys from './queryKeys';

export interface FilterOptionsParams {
  app?: string;
  network?: string;
}

export interface FilterOptionsResponse {
  hypothesis: string[];
  customer: string[];
  technology: string[];
  flow: string[];
}

export const getFilterOptions = async (
  { params }: { params: FilterOptionsParams },
  signal?: AbortSignal,
): Promise<FilterOptionsResponse> => {
  const res = await apiClient.get<FilterOptionsResponse>(
    'api/v1/creative_manager/filter_options',
    {
      params,
      signal,
      paramsSerializer: (prms) =>
        queryString.stringify(prms, { arrayFormat: 'comma' }),
    },
  );
  return res.data;
};

interface UseFilterOptionsOptions {
  params: FilterOptionsParams;
  config?: SynchronousQueryConfig<typeof getFilterOptions, FilterOptionsResponse>;
}

export const useFilterOptions = ({ params, config }: UseFilterOptionsOptions) => {
  return useQuery({
    staleTime: 0,
    refetchOnMount: true,
    ...config,
    queryFn: ({ signal }) => getFilterOptions({ params }, signal),
    queryKey: queryKeys.filterOptions<FilterOptionsParams>(params),
  });
};
